// extracted by mini-css-extract-plugin
module.exports = {"hiddenMdDown":"Transactions_hiddenMdDown__1p6Rm","fixWidthXSS":"Transactions_fixWidthXSS__3LUz_","fixWidth":"Transactions_fixWidth__2pRCx"};